// extracted by mini-css-extract-plugin
export default {"formLabel":"SubmitBills_formLabel__o0d34","errorMsg":"SubmitBills_errorMsg__wOeUs"};